import { FilterParamsType } from '@/api/helpers/apiParamsHelpers';
import { REVERSED_DEFAULT_DATE_FORMAT, formatDate } from '@/helpers/dateHelpers/dateHelpers';
import { isValid, parseISO } from 'date-fns';

export const getInitialQueryFilters = (filters: FilterParamsType, startDate: string, endDate: string) => {
  if (filters?.date_created_after && filters?.date_created_before) {
    const filtersDateStart = parseISO(filters?.date_created_after);
    const filtersDateEnd = parseISO(filters?.date_created_before);

    if (isValid(filtersDateStart) && isValid(filtersDateEnd)) {
      return filters;
    }
  }

  const dateFilters = {
    date_created_after: formatDate(startDate, REVERSED_DEFAULT_DATE_FORMAT),
    date_created_before: formatDate(endDate, REVERSED_DEFAULT_DATE_FORMAT),
  };

  return { ...filters, ...dateFilters };
};
